"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ROUTES } from "@/lib/config/routes";
export default function Footer() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentYear = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-xs text-foreground/50">© {currentYear} AI UI Wrapper</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href={ROUTES.DOCS} className="text-xs text-foreground/60 hover:text-foreground transition-colors">Documentation</Link>;
    t3 = <Link href={ROUTES.PRIVACY_POLICY} className="text-xs text-foreground/60 hover:text-foreground transition-colors">Privacy Policy</Link>;
    t4 = <Link href={ROUTES.TERMS} className="text-xs text-foreground/60 hover:text-foreground transition-colors">Terms of Service</Link>;
    t5 = <Link href={ROUTES.CONTACT} className="text-xs text-foreground/60 hover:text-foreground transition-colors">Contact</Link>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <footer className="flex-shrink-0 border-t border-white/30 bg-white/40 backdrop-blur-md px-4 py-3"><div className="mx-auto flex max-w-6xl items-center justify-between">{t1}<nav className="flex items-center gap-4">{t2}{t3}{t4}{t5}<a href="https://github.com/deepthinklabs-ai/ai-ui-wrapper" target="_blank" rel="noopener noreferrer" className="text-foreground/60 hover:text-foreground transition-colors" title="GitHub"><svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg></a></nav></div></footer>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}